import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { storeWithExpiration } from '../../utils/common';
import { getDataSetVersionReport, getReportLink, setSelectedVersion } from '../../actions/reports';
import SingleDatasetReports from './SingleDatasetReports';

export class SingleDatasetReportsContainer extends Component {
  static propTypes = {
    dataset: PropTypes.object,
    datasetId: PropTypes.number,
    isIndexItem: PropTypes.bool.isRequired,
    selectedVersion: PropTypes.number,
    versions: PropTypes.array,
    versionReports: PropTypes.object,
    getDataSetVersionReportAction: PropTypes.func.isRequired,
    getReportLinkAction: PropTypes.func.isRequired,
    setSelectedVersionAction: PropTypes.func.isRequired,
  };

  static defaultProps = {
    dataset: null,
    datasetId: null,
    selectedVersion: null,
    versions: null,
    versionReports: null,
  };

  constructor(props) {
    super(props);
    this.getReportDownloadLink = this.getReportDownloadLink.bind(this);
    this.handleVersionSelectChange = this.handleVersionSelectChange.bind(this);
  }

  getReportDownloadLink = report => {
    const { datasetId, getReportLinkAction, selectedVersion } = this.props;
    const token = storeWithExpiration.get('token');
    getReportLinkAction(datasetId, selectedVersion, report, token);
  };

  handleVersionSelectChange = e => {
    const { setSelectedVersionAction } = this.props;
    const selectedVersion = parseInt(e.target.value, 10);
    setSelectedVersionAction(selectedVersion);
    this.submitVersionChange(selectedVersion);
  };

  submitVersionChange = selectedVersion => {
    const { datasetId, getDataSetVersionReportAction } = this.props;
    const token = storeWithExpiration.get('token');
    getDataSetVersionReportAction(datasetId, selectedVersion, token);
  };

  renderNoTable = () => (
    <div className="no-reports text-muted">
      <p>To preview a report, please select a list</p>
    </div>
  );

  render() {
    const {
      dataset,
      datasetId,
      isIndexItem,
      selectedVersion,
      versions,
      versionReports,
    } = this.props;

    return datasetId ? (
      <div>
        <SingleDatasetReports
          dataset={dataset}
          datasetId={datasetId}
          getReportDownloadLink={this.getReportDownloadLink}
          handleVersionSelectChange={this.handleVersionSelectChange}
          isIndexItem={isIndexItem}
          selectedVersion={selectedVersion}
          versions={versions}
          versionReports={versionReports}
        />
      </div>
    ) : (
      this.renderNoTable()
    );
  }
}

const mapStateToProps = state => {
  const { reports } = state;
  const selectedDataset = reports.get('selectedDataset');
  const versionReports = reports.get('datasetVersionReport');
  const dataset = {
    id: selectedDataset.get('id'),
    name: selectedDataset.get('name'),
  };
  const datasetId = selectedDataset.get('id');
  const selectedVersion = selectedDataset.get('selectedVersion');
  const versions = selectedDataset.get('versions');
  return {
    dataset,
    datasetId,
    selectedVersion,
    versions,
    versionReports,
  };
};

export default connect(mapStateToProps, {
  getDataSetVersionReportAction: getDataSetVersionReport,
  getReportLinkAction: getReportLink,
  setSelectedVersionAction: setSelectedVersion,
})(SingleDatasetReportsContainer);
